module.exports = __webpack_public_path__ + "static/media/EasyFill_logo.96c38e4f.png";